import { Link, Navigate, useNavigate, useParams } from 'react-router';
import { ROUTES } from '@/app/router/routes';
import { ChevronRightIcon, ClipboardCheckIcon } from '@/components/icons';
import { ErrorNotice, LoadingState, PageHeading } from '@/components/portal/PortalPage';
import { SatisfactionDialog } from './SatisfactionDialog';
import { formatMonth } from './timesheet-labels';
import { useSatisfaction, useSubmitTimesheet, useTimesheet } from './useTimesheets';

export const TimesheetSatisfactionPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const query = useTimesheet(id);
  const satisfaction = useSatisfaction(id, Boolean(query.data?.permissions.canSubmit));
  const submit = useSubmitTimesheet();
  if (query.isPending) return <LoadingState>Chargement de votre compte rendu…</LoadingState>;
  if (query.isError)
    return (
      <ErrorNotice
        onRetry={() => {
          void query.refetch();
        }}
      >
        {query.error.message}
      </ErrorNotice>
    );
  const timesheet = query.data;
  if (!timesheet.permissions.canSubmit)
    return <Navigate to={ROUTES.timesheet(timesheet.id)} replace />;
  const back = () => {
    void navigate(ROUTES.timesheet(timesheet.id));
  };
  return (
    <div className="portal-page">
      <nav className="portal-breadcrumb" aria-label="Fil d’Ariane">
        <Link to={ROUTES.timesheet(timesheet.id)}>{formatMonth(timesheet.periodMonth)}</Link>
        <ChevronRightIcon aria-hidden />
        <span aria-current="page">Mon avis</span>
      </nav>
      <PageHeading
        title="Votre mois, votre avis"
        description={`Dernière étape avant l’envoi de votre CRA de ${formatMonth(timesheet.periodMonth)}.`}
        icon={<ClipboardCheckIcon />}
      />
      <div className="portal-questionnaire">
        <SatisfactionDialog
          key={timesheet.id}
          context={satisfaction.data}
          loading={satisfaction.isPending}
          error={satisfaction.error ?? submit.error}
          pending={submit.isPending}
          onCancel={back}
          onRetry={() => {
            void satisfaction.refetch();
          }}
          onSubmit={(answers) => {
            if (!satisfaction.data) return;
            submit.mutate(
              { id: timesheet.id, satisfaction: { version: satisfaction.data.version, answers } },
              { onSuccess: back },
            );
          }}
        />
      </div>
    </div>
  );
};
